module.exports = __webpack_public_path__ + "static/media/USDT_BUSD_Biswap.25b84a7a.png";